module.exports = __webpack_public_path__ + "static/media/graphic11.762446a8.png";